import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Card, Empty, Table } from 'antd'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'

import { ColumnsType } from 'antd/lib/table'
import { getOrganizationInfoStats, IOrganizationInfoPayload, IOrganizationInfoRecord } from '../../../reducers/statistics/actions'
import MyOrganizationJobsLifecycle from './MyOrganizationJobsLifecycle'

type Columns = ColumnsType<IOrganizationInfoRecord>

const MyOrganizations = () => {
	const dispatch = useDispatch()

	const { t } = useTranslation('pages')

	const [data, setData] = React.useState<IOrganizationInfoPayload | null>()

	useEffect(() => {
		dispatch(getOrganizationInfoStats((data) => {
			setData(data)
		}))
	}, [dispatch])

	const columns: Columns = [
		{
			title: i18next.t('pages:Názov'),
			dataIndex: 'organizationName',
			key: 'organizationName',
			ellipsis: true,
			sorter: true,
			width: 210,
			render: (value) => value || '-'
		},
		{
			title: i18next.t('pages:Počet zamestnancov'),
			dataIndex: 'workerCount',
			key: 'workerCount',
			ellipsis: true,
			sorter: true,
			width: 210,
			render: (value) => value || '-'
		},
		{
			title: i18next.t('pages:Mesiac'),
			dataIndex: 'date',
			key: 'date',
			ellipsis: true,
			sorter: true,
			width: 210,
			render: (value) => value || '-'
		},
		{
			title: i18next.t('pages:Počet uprataní v aktuálnom mesiaci'),
			dataIndex: 'finishCount',
			key: 'finishCount',
			ellipsis: true,
			sorter: true,
			width: 210,
			render: (value) => value || '-'
		}
	]

	return (
		<div className={'page-wrapper'}>
			<Card className={'my-2'} bordered={false}>
				<div className={'font-bold text-lg mb-2'}>{t('pages:My organization')}</div>
				<Table
					className={'general-table'}
					columns={columns}
					dataSource={data?.data || []}
					style={{ marginTop: 0 }}
					showSorterTooltip={false}
					pagination={false}
					locale={{
						emptyText: (
							<Empty description={t('pages:Žiadne dáta')} />
						)
					}}
					size={'small'}
				/>
			</Card>
			<MyOrganizationJobsLifecycle />
		</div>
	)
}

export default MyOrganizations
